import { http } from "@/shared/api/axios";
import type { ShiftCategory, ShiftCategoryRequest } from "../model/types";

export const fetchShiftCategories = async (): Promise<ShiftCategory[]> => {
  const response = await http.get<ShiftCategory[]>(
    "/v1/account/configurations/shift-categories"
  );
  return response.data;
};

export const createShiftCategory = async (
  data: ShiftCategoryRequest
): Promise<ShiftCategory> => {
  const response = await http.post<ShiftCategory>(
    "/v1/account/configurations/shift-categories",
    data
  );
  return response.data;
};

export const updateShiftCategory = async (
  id: number,
  data: ShiftCategoryRequest
): Promise<ShiftCategory> => {
  const response = await http.put<ShiftCategory>(
    `/v1/account/configurations/shift-categories/${id}`,
    data
  );
  return response.data;
};

export const deleteShiftCategory = async (id: number): Promise<void> => {
  await http.delete(`/v1/account/configurations/shift-categories/${id}`);
};
